import React from 'react'
import '../style/impact.css'
const Impact = () => {
    return (
        <>
            <div className='container'>
                <div className='ok' style={{ display: 'flex', justifyContent: 'center', marginTop:'25px' }} data-aos="fade-up" data-aos-offset="250" data-aos-duration="1500" mirror='true'>
                    <h3 style={{ padding: '7px', color:'rgb(13 92 126)' }}>Our Proven Impacts</h3>
                    <img src="https://www.svgrepo.com/show/246818/stats-growth.svg" width={'40px'} height={'40px'} style={{ marginRight: '25px', marginTop:'10px' }} alt="growth" />
                </div>
            </div>
            <section className='hell' id='bgServe' style={{ justifyContent: "center", textAlign: 'center', marginTop: '50px', position: 'relative', height: '400px' }}>
                <div className='container'>
                    <div className='row' style={{ textAlign: 'center' }} id='rI'>
                        <div className='col' id='iCol'  data-aos="fade-up" data-aos-offset="250" data-aos-duration="1500" mirror='true' >
                            <span data-val="1000" className='num' style={{  color:'white', fontWeight: 'bold', fontFamily: 'cursive' }}>1,000+</span>
                            <p className='pI' style={{ fontWeight: "bold", fontFamily: "initial", color:"palegoldenrod" }}>Training&nbsp;Conducted</p></div>
                        <div className='col' id='iCol'  data-aos="fade-up" data-aos-offset="250" data-aos-duration="1500" mirror='true' >
                            <span data-val="40000" className='num' style={{ color:'white', fontWeight: 'bold', fontFamily: 'cursive' }}>40,000+</span>
                            <p className='pI' style={{ fontWeight: "bold", fontFamily: "initial", color:"palegoldenrod" }}>People&nbsp;Impacted</p></div>
                        <div className='col' id='iCol'  data-aos="fade-up" data-aos-offset="250" data-aos-duration="1500" mirror='true' >
                            <span data-val="150" className='num' style={{  color:'white',fontWeight: 'bold', fontFamily: 'cursive' }}>150+</span>
                            <p className='pI' style={{  fontWeight: "bold", fontFamily: "initial", color:"palegoldenrod" }}>Business&nbsp;Transformed</p>
                        </div>
                        <div className='col' id='iCol'  data-aos="fade-up" data-aos-offset="250" data-aos-duration="1500" mirror='true' >
                            <span data-val="100" className='num' style={{  color:'white',fontWeight: 'bold', fontFamily: 'cursive' }}>100%</span>
                            <p className='pI' style={{ fontWeight: "bold", fontFamily: "initial", color:"palegoldenrod" }}>Satisfaction</p>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Impact
